<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="600px" @close="dialogVisible = false">
    
    <el-form label-width="100px" mode="form" size="small">
      <!-- 支付方式选择，支付单号输入 -->
      <el-form-item label="支付方式">
        <el-select placeholder="请选择支付方式" v-model="form.pay_type" style="width: 100%;">
          <el-option label="支付宝" value="ALIPAY"></el-option>
          <el-option label="微信" value="WECHAT"></el-option>
          <el-option label="银行" value="BANK"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付单号">
        <el-input placeholder="请输入支付单号" v-model="form.pay_off_no"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import useApi from "@/api/useApi.js"
export default{
  data(){
    return { 
      form: {
        order_id: 0,
        period: 0,
        amount: 0,
        pay_off_no: "",
        pay_type: "ALIPAY"
      },
      dialogVisible: false }
  },
  methods: {
    open(row) {
      this.form.order_id = row.order_id;
      this.form.period = row.current_period;
      this.form.amount = row.price;
      this.dialogVisible = true;
    },
    async submit() {
      const res = await useApi().repayWithholdPlan(this.form);
      if(res.code == 1){
        this.$message.success("操作成功");
        this.dialogVisible = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/AntWithHold/AntReplay.vue